import { SAVE_MULTI_LANG_DATA } from "./action";

const initState = {
  multiLang: null,
};

export const multiLangReducer = (state = initState, action) => {
  switch (action.type) {
    case SAVE_MULTI_LANG_DATA:
      return {
        ...state,
        multiLang: action.payload,
      };
    default:
      return state;
  }
};
